export const Setting = {
  /*
   Container Setting
   */
  Container: {
    w: 400,
    h: 247
  },
  /*
   AWS Cognito Setting
   */
  S3: {
    Enable: false,
    Region: "",
    PoolId: "",
    Bucket: ""
  }
};



// WEBPACK FOOTER //
// ./src/lib/Config.js